export default __webpack_public_path__ + "/assets/vivi-book-residenza-lg.jpg";